<template>
    <div>
        <v-hover v-slot:default="{ hover }">

            <v-card
                class="my-3 px-6 align-center d-flex property-unit-card"
                :elevation="hover ? 1 : 0"
                outlined
                :height="isMobile ? 120 : 90"
            >
                <v-row>
                    <v-col class="d-flex justify-space-between align-center">
                        <v-hover v-slot:default=" { hover } ">
                            <v-avatar
                                size="50"
                                class="roommate-avatar mr-4"
                                tile
                                :class="hover ? 'elevation-8' : ''"
                                @click="showFloorPlan = true"
                            >
                                <v-img :src="propertyUnit.floor_plan_image_url">
                                    <template v-slot:placeholder>
                                        <v-img
                                            src="@/assets/icons/icon-apt.svg"
                                            max-width="50"
                                            min-width="50"
                                            max-height="50"
                                            min-height="50"
                                        ></v-img>
                                    </template>
                                </v-img>
                            </v-avatar>
                        </v-hover>
                        <v-row>
                            <v-col cols="12" sm="7" class="py-0">
                                <h4>
                                    {{ `${propertyUnit.name}` }}
                                    <span v-if="!isMobile" class="ml-2">
                                        <span
                                            class="link-color"
                                            @click.prevent="showAvailabilities = true"
                                        >
                                            {{ propertyUnitAvailabilityDate | availableDate }}
                                        </span>
                                    </span>
                                </h4>
                                <p v-if="isMobile">
                                    <span
                                        class="link-color"
                                        @click.prevent="showAvailabilities = true"
                                    >
                                        {{ propertyUnitAvailabilityDate | availableDate }}
                                    </span>
                                </p>
                                <p>
                                    {{ `${propertyUnit.number_of_bedrooms} bd | ${propertyUnit.number_of_baths} ba | ${propertyUnit.square_feet} sq ft` }}
                                </p>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="5"
                                class="py-0 text-sm-right d-flex justify-space-between align-center">
                                <div class="price-section">
                                    <h4>${{ Math.ceil(propertyUnit.price) }}</h4>
                                    <p class="price-label">{{ housingType === 'shared' ? 'per bed' : 'per unit' }}</p>
                                </div>
                                <div class="d-flex align-center buttons-section">
                                    <v-btn
                                        v-if="propertyUnitAvailabilityDate !== null"
                                        color="primary"
                                        @click="$emit('applyTo', propertyUnit.id)"
                                        class="apply-now-btn mr-2"
                                        depressed
                                    >
                                        Apply Now!
                                    </v-btn>
                                    <template v-else>
                                        <v-btn
                                            v-if="!isOnWaitlist"
                                            :loading="isWaitlistLoading"
                                            :disabled="isWaitlistLoading"
                                            @click="$emit('joinWaitlist', propertyUnit.id)"
                                            class="btn-edurent not-selected mr-2"
                                            depressed
                                        >
                                            Join Waitlist
                                        </v-btn>
                                        <v-btn
                                            v-else
                                            :loading="isWaitlistLoading"
                                            :disabled="isWaitlistLoading"
                                            @click="$emit('removeFromWaitlist', propertyUnit.id)"
                                            class="btn-edurent not-selected leave-waitlist mr-2"
                                            depressed
                                        >
                                            Leave Waitlist
                                        </v-btn>
                                    </template>
                                    <v-btn
                                        icon
                                        small
                                        @click.stop="toggleFavorite"
                                        @mouseover="hoverFavorite = true"
                                        @mouseleave="hoverFavorite = false"
                                    >
                                        <v-icon :color="favoriteColor" size="22">{{ favoriteIcon }}</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>

                    </v-col>
                </v-row>
            </v-card>
        </v-hover>

        <v-dialog width="500" v-model="showFloorPlan">
            <PropertyFloorPlanImage :property-unit="propertyUnit" :available-date="propertyUnitAvailabilityDate"></PropertyFloorPlanImage>
        </v-dialog>

        <v-dialog width="500" v-model="showAvailabilities">
            <v-card>
                <v-card-title class="d-flex justify-space-between pb-6">
                    Property Unit Availabilities
                    <v-hover>
                        <v-btn icon slot-scope="{ hover}" :elevation="hover ? 4 : 0" @click="showAvailabilities= false">
                            <v-icon :color="hover ? 'primary' : ''">mdi-close</v-icon>
                        </v-btn>
                    </v-hover>
                </v-card-title>
                <v-card-text>
                    <div v-if="propertyUnit.property_unit_availabilities.length > 0">
                        <div v-for="item in propertyUnit.property_unit_availabilities" :key="item.id">
                            <div class="d-flex justify-space-between pt-4">
                                <p>Available Date: <strong>{{ item.available_date | formatDate }}</strong></p>
                                <p>Price: <strong>${{ item.price > 0 ? Math.ceil(item.price) : Math.ceil(propertyUnit.price) }}</strong></p>
                            </div>
                            <v-divider></v-divider>
                        </div>
                    </div>
                    <div v-else>
                        <h3>No availabilities</h3>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import PropertyFloorPlanImage from "@/components/PropertyFloorPlanImage";
import PropertyService from "@/services/property.service";

export default {
    name: 'PropertyUnitBlock',
    components: {PropertyFloorPlanImage},
    props: ['propertyUnit', 'isWaitlistLoading', 'housingType'],
    data() {
        return {
            showFloorPlan: false,
            showAvailabilities: false,
            isMobile: false,
            hoverFavorite: false,
            isLiked: false
        }
    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        isUserLoggedIn() {
            return this.$store.getters.isUserLoggedIn;
        },
        isFavorited() {
            if (!this.isUserLoggedIn || !this.propertyUnit.favorite_property_units) {
                return false;
            }
            return this.propertyUnit.favorite_property_units.some(
                fav => fav.user_id === this.user.id
            );
        },
        favoriteIcon() {
            return (this.isLiked || this.hoverFavorite) ? 'mdi-heart' : 'mdi-heart-outline';
        },
        favoriteColor() {
            return (this.isLiked || this.hoverFavorite) ? '#FF4141' : 'rgba(0,0,0,0.5)';
        },
        propertyUnitAvailabilityDate() {
            const unit = this.propertyUnit

            if (!unit.property_unit_availabilities || unit.property_unit_availabilities.length === 0) {
                return null
            }

            return unit.property_unit_availabilities.reduce((soonest, availability) => {
                const availableDate = moment(availability.available_date)
                const soonestDate = moment(soonest)

                if (soonest === null || availableDate.isBefore(soonestDate)) {
                    return availability.available_date
                }

                return soonest
            }, null)
        },
        isOnWaitlist() {
            if (!this.user || !this.user.property_unit_waitlists) {
                return false;
            }
            return this.user.property_unit_waitlists.some(
                item => item.property_unit_id === this.propertyUnit.id
            );
        }
    },
    filters: {
        availableDate(value) {
            if (value === null) {
                return "No Availability"
            }

            const today = moment()
            const date = moment(value)

            if (date.isBefore(today)) {
                return "Available now"
            }

            const oneYearInFuture = today.add(1, 'y')

            if (date.isSameOrAfter(oneYearInFuture)) {
                return "Available " + date.format("MMMM D YYYY")
            }

            return "Available " + date.format("MMMM D")
        },
        formatDate(value) {
            return moment(value).format('l')
        }
    },
    methods: {
        async toggleFavorite() {
            if (!this.isUserLoggedIn) {
                this.$store.dispatch('setSignInModal', true);
                return;
            }
            this.isLiked = !this.isLiked;
            await PropertyService.togglePropertyUnitLike(this.propertyUnit.id, {
                property_unit_id: this.propertyUnit.id,
                user_id: this.user.id
            });
            this.$store.dispatch('getProperties');
            this.$store.dispatch('getFavoriteProperties');
        }
    },
    mounted() {
        this.isMobile = window.innerWidth < 600;
        this.isLiked = this.isFavorited;
    },
    watch: {
        isFavorited: {
            handler(newVal) {
                this.isLiked = newVal;
            },
            immediate: true
        }
    }
}
</script>

<style scoped>

.link-color {
    color: #2d76e3;
    cursor: pointer;
}

.property-unit-card {
    border-radius: 10px !important;
}

.property-unit-card h4 {
    font-size: 16px !important;
    font-weight: 700;
}

.property-unit-card h4 span {
    font-style: italic;
    font-weight: 400;
    font-size: 14px !important;
}

.property-unit-card p {
    font-size: 14px !important;
}

.price-section {
    min-width: 80px;
    text-align: right;
}

.buttons-section {
    margin-left: 16px;
}

@media (max-width: 768px) {
    .buttons-section {
        margin-left: 8px;
    }
}

.apply-now-btn {
    height: 36px !important;
    min-width: 120px !important;
    font-size: 0.875rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
}

@media (max-width: 768px) {
    .apply-now-btn {
        height: 32px !important;
        min-width: 100px !important;
        font-size: 0.75rem !important;
    }
}

.btn-edurent {
    height: 27px !important;
    min-width: 100px !important;
    background: #f4f5f7 !important;
    font-size: 0.675rem !important;
}

@media (max-width: 768px) {
    .btn-edurent {
        height: 22px !important;
        min-width: 82px !important;
    }
}

.leave-waitlist {
    color: #d21919 !important;
    border: 1px solid #d21919 !important;
}

.price-label {
    font-size: 12px !important;
    font-weight: 400;
    font-style: normal !important;
    color: #666;
    margin: 0 !important;
    line-height: 1.2 !important;
}

</style>
